
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"56 56 200 88"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"Logos"}},[_c('g',{attrs:{"id":"Logo__x2013__Horizontal_1A_12_"}},[_c('path',{attrs:{"d":"M95 96.8v4c0 .4-.4.8-.8.8h-5c-.2 0-.4.2-.4.4v21.2c0 .4-.4.8-.8.8h-4c-.4 0-.8-.4-.8-.8V102c0-.2-.2-.4-.4-.4h-5c-.4 0-.8-.4-.8-.8v-4c0-.4.4-.8.8-.8h16.4c.4 0 .8.4.8.8zm22-.8h-4c-.4 0-.8.4-.8.8v18.8c0 1.8-1.4 3.2-3.9 3.2-2.4 0-3.8-1.4-3.8-3.2V96.8c0-.4-.4-.8-.8-.8h-4c-.4 0-.8.4-.8.8v18.8c0 4.8 4 8.8 9.4 8.8 5.5 0 9.5-4 9.5-8.8V96.8c0-.4-.4-.8-.8-.8zm22.6 0h-4c-.4 0-.8.4-.8.8v15c0 .2-.3.3-.4.1l-5.5-15.2c-.1-.4-.4-.7-1-.7h-4.8c-.4 0-.8.4-.8.8v26.4c0 .4.4.8.8.8h4c.4 0 .8-.4.8-.8v-13.8c0-.2.3-.3.4-.1l5.4 14c.1.3.4.7 1.1.7h4.7c.4 0 .8-.4.8-.8V96.8c.1-.4-.3-.8-.7-.8zm20.7 22.4h-9.5c-.2 0-.4-.2-.4-.4v-4.8c0-.2.2-.4.4-.4h9c.4 0 .8-.4.8-.8v-4c0-.4-.4-.8-.8-.8h-9c-.2 0-.4-.2-.4-.4V102c0-.2.2-.4.4-.4h9.3c.4 0 .8-.4.8-.8v-4c0-.4-.4-.8-.8-.8h-14.5c-.4 0-.8.4-.8.8v26.4c0 .4.4.8.8.8h14.7c.4 0 .8-.4.8-.8v-4c0-.4-.4-.8-.8-.8zM256 59v62c0 1.7-1.3 3-3 3h-69v17c0 1.7-1.3 3-3 3H59c-1.7 0-3-1.3-3-3V79c0-1.7 1.3-3 3-3h119V59c0-1.7 1.3-3 3-3h72c1.7 0 3 1.3 3 3zm-78 23H62.5c-.3 0-.5.2-.5.5v55c0 .3.2.5.5.5h115c.3 0 .5-.2.5-.5V82zm35.8 17.4c0-.4-.4-.8-.8-.8h-3.4c-.2 0-.4-.2-.4-.4V81.8c0-.2.2-.4.4-.4h3c.4 0 .8-.4.8-.8v-3.8c0-.4-.4-.8-.8-.8h-12.4c-.4 0-.8.4-.8.8v3.8c0 .4.4.8.8.8h3c.2 0 .4.2.4.4v16.4c0 .2-.2.4-.4.4h-3.4c-.4 0-.8.4-.8.8v3.8c0 .4.4.8.8.8H213c.4 0 .8-.4.8-.8v-3.8zm22.4-22.6c0-.4-.4-.8-.8-.8h-4c-.4 0-.8.4-.8.8v15c0 .2-.3.3-.4.1l-5.5-15.2c-.1-.4-.4-.7-1-.7H219c-.4 0-.8.4-.8.8v26.4c0 .4.4.8.8.8h4c.4 0 .8-.4.8-.8V89.4c0-.2.3-.3.4-.1l5.4 14c.1.3.4.7 1.1.7h4.7c.4 0 .8-.4.8-.8V76.8z","fill":"#14d8cc","id":"Logo_2_"}})])])])
          )
        }
      }
    